import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Mathématiques",
  icon: "🔢",
  tagline: "Formation rigoureuse en mathématiques pures et appliquées",
  duree: "3 à 5 ans",
  diplome: "Licence/Master",
  mode: "Présentiel",
  nombreDebouches: "8",
  description: "La filière Mathématiques offre une formation solide en mathématiques fondamentales et appliquées. Notre programme développe le raisonnement logique, la rigueur scientifique et les compétences analytiques nécessaires pour exceller dans divers domaines.",
  objectifs: [
    "Maîtriser les fondamentaux des mathématiques",
    "Développer la rigueur et le raisonnement logique",
    "Acquérir des compétences en mathématiques appliquées",
    "Maîtriser les outils informatiques pour les mathématiques",
    "Préparer à l'enseignement et la recherche"
  ],
  programme: [
    { titre: "Licence 1 & 2", matieres: ["Algèbre linéaire", "Analyse mathématique", "Probabilités et statistiques", "Géométrie", "Informatique pour les mathématiques", "Logique mathématique"] },
    { titre: "Licence 3 & Master", matieres: ["Analyse complexe", "Topologie", "Théorie des nombres", "Mathématiques financières", "Modélisation mathématique", "Méthodes numériques"] }
  ],
  debouches: [
    { titre: "Enseignant", description: "Enseignement des mathématiques" },
    { titre: "Chercheur", description: "Recherche en mathématiques" },
    { titre: "Actuaire", description: "Analyse des risques financiers" },
    { titre: "Data scientist", description: "Analyse et modélisation de données" },
    { titre: "Ingénieur statisticien", description: "Analyse statistique avancée" },
    { titre: "Consultant quantitatif", description: "Analyse quantitative en finance" }
  ],
  competences: ["Raisonnement logique et rigueur scientifique", "Maîtrise des mathématiques avancées", "Compétences en modélisation et simulation", "Capacité d'abstraction et de synthèse", "Maîtrise des outils informatiques scientifiques"]
};

export default function Mathematiques() {
  return <FiliereTemplate filiere={filiereData} />;
}